import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



    
    import EffectiveContractNotificationSnackbarStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/eff_contracts/effective_contract_notification_snackbar_store.js"

    
    import EffectiveContractStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/eff_contracts/effective_contract_store.js"

    
    import AdminPanelStmHostelStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/hostel/adminPanelStmHostel_store.js"

    
    import FormingContractHostelStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/hostel/formingContractHostel_store.js"

    
    import HostelOrdersStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/hostel/hostelOrders_store.js"

    
    import InteractionStatementStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/hostel/interactionStatement_store.js"

    
    import MainHostelStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/hostel/mainHostel_store.js"

    
    import PlacesInDormitoriesStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/hostel/placesInDormitories_store.js"

    
    import AchievementFormStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/achievement_form_store.js"

    
    import AchievementKindStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/achievement_kind_store.js"

    
    import AchievementStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/achievement_store.js"

    
    import AchievementTuningStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/achievement_tuning_store.js"

    
    import AchievementTypeStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/achievement_type_store.js"

    
    import ErrorPortfolioStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/error_portfolio_store.js"

    
    import PortfolioStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/portfolio/portfolio_store.js"

    
    import ScholarshipCommentStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/scholarship/scholarship_comment_store.js"

    
    import ScholarshipCompetitionStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/scholarship/scholarship_competition_store.js"

    
    import ScholarshipMeetingStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/scholarship/scholarship_meeting_store.js"

    
    import ScholarshipVoteStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/scholarship/scholarship_vote_store.js"

    
    import StudyEstEukTechMapAdditDataStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/study/studyEstEukTechMapAdditData_store.js"

    
    import StudyEstEukTechMapCommissionStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/study/studyEstEukTechMapCommission_store.js"

    
    import StudyEstEukTechMapStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/study/studyEstEukTechMap_store.js"

    
    import StudyEstimationEukStore from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/stores/application/study/studyEstimationEuk_store.js"


const store = new Vuex.Store({
    modules: {
        
            
            effective_contract_notification_snackbar: EffectiveContractNotificationSnackbarStore,
        
            
            effective_contract: EffectiveContractStore,
        
            
            adminPanelStmHostel: AdminPanelStmHostelStore,
        
            
            formingContractHostel: FormingContractHostelStore,
        
            
            hostelOrders: HostelOrdersStore,
        
            
            interactionStatement: InteractionStatementStore,
        
            
            mainHostel: MainHostelStore,
        
            
            placesInDormitories: PlacesInDormitoriesStore,
        
            
            achievement_form: AchievementFormStore,
        
            
            achievement_kind: AchievementKindStore,
        
            
            achievement: AchievementStore,
        
            
            achievement_tuning: AchievementTuningStore,
        
            
            achievement_type: AchievementTypeStore,
        
            
            error_portfolio: ErrorPortfolioStore,
        
            
            portfolio: PortfolioStore,
        
            
            scholarship_comment: ScholarshipCommentStore,
        
            
            scholarship_competition: ScholarshipCompetitionStore,
        
            
            scholarship_meeting: ScholarshipMeetingStore,
        
            
            scholarship_vote: ScholarshipVoteStore,
        
            
            studyEstEukTechMapAdditData: StudyEstEukTechMapAdditDataStore,
        
            
            studyEstEukTechMapCommission: StudyEstEukTechMapCommissionStore,
        
            
            studyEstEukTechMap: StudyEstEukTechMapStore,
        
            
            studyEstimationEuk: StudyEstimationEukStore,
        
    }
})

export default store